import * as React from "react";
import type { SVGProps } from "react";
const Bar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_4873)">
      <path
        fill="currentColor"
        d="M1.5 3c0-.8297.6703-1.5 1.5-1.5h13.5c.8297 0 1.5.6703 1.5 1.5v1.5h2.4c1.9875 0 3.6 1.6125 3.6 3.6v4.7859c0 1.425-.8391 2.7141-2.1375 3.2907L18 17.8922V19.5c0 1.6547-1.3453 3-3 3H4.5c-1.6547 0-3-1.3453-3-3zM18 14.6063l2.6437-1.1766c.2157-.0984.3563-.3094.3563-.5485V8.0953c0-.3328-.2672-.6-.6-.6L18 7.5zM7.5 6.75c0-.4125-.3375-.75-.75-.75S6 6.3375 6 6.75v10.5c0 .4125.3375.75.75.75s.75-.3375.75-.75zm3 0c0-.4125-.3375-.75-.75-.75S9 6.3375 9 6.75v10.5c0 .4125.3375.75.75.75s.75-.3375.75-.75zm3 0c0-.4125-.3375-.75-.75-.75s-.75.3375-.75.75v10.5c0 .4125.3375.75.75.75s.75-.3375.75-.75z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_4873">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Bar;
